/**
 * Route for `awin-integration-api-key-publisher-id`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AwinIntegrationApiKeyPublisherIdPage } from "../features/awin-integration-api-key-publisher-id/AwinIntegrationApiKeyPublisherIdPage";

export const awinIntegrationApiKeyPublisherIdRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/awin-integration-api-key-publisher-id",
	component: AwinIntegrationApiKeyPublisherIdPage,
});

export default awinIntegrationApiKeyPublisherIdRoute;
